module.exports = __webpack_public_path__ + "static/media/icon-hand.8d854104.webp";